import { render, staticRenderFns } from "./PageEditStack.vue?vue&type=template&id=1cdb4ad4&"
import script from "./PageEditStack.vue?vue&type=script&lang=js&"
export * from "./PageEditStack.vue?vue&type=script&lang=js&"
import style0 from "./PageEditStack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports